var map;
function initialize() {
    var mapOptions = {
        zoom: 15,
        draggable: false,
        controlSize: 24,
        streetViewControl: false,
        scrollwheel: false,
        center: new google.maps.LatLng(46.9474339, 7.4567827),
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
    var markerImage = {
        url: '/assets/images/maps-icon-93x128@2x.png',
        scaledSize: new google.maps.Size(93, 128),
        origin: new google.maps.Point(0,0),
        anchor: new google.maps.Point(46, 128)
    };
    var markerOptions = {
        map: map,
        position: new google.maps.LatLng(46.9475621, 7.4565956),
        title: "Suresh Restaurant&nbsp;&amp;&nbsp;Bar",
        icon: markerImage,
        optimized: false
    };
    marker = new google.maps.Marker(markerOptions);
}
google.maps.event.addDomListener(window, 'load', initialize);
google.maps.event.addDomListener(window, 'resize', function(){
    var center = map.getCenter();
    google.maps.event.trigger(map, "resize");
    map.setCenter(center);
});
